"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      d: "M11.025 0H8.772c-.316 0-.58.107-.794.32-.214.214-.32.478-.32.795v5.692c0 .316.106.58.32.794.213.214.478.32.794.32h2.253c.503 0 .94-.177 1.314-.533.373-.356.608-.81.702-1.364h2.301V5.42c.95.4 1.812.992 2.585 1.778 1.569 1.598 2.353 3.55 2.353 5.856 0 2.287-.808 4.235-2.424 5.842-1.617 1.607-3.569 2.41-5.856 2.41-2.288 0-4.24-.799-5.856-2.396-1.616-1.598-2.424-3.55-2.424-5.856a1.29 1.29 0 0 0-.383-.95 1.29 1.29 0 0 0-.95-.383 1.29 1.29 0 0 0-.95.383 1.29 1.29 0 0 0-.383.95c0 1.531.284 2.959.85 4.282a10.976 10.976 0 0 0 2.34 3.474 10.934 10.934 0 0 0 3.488 2.34c1.333.566 2.756.85 4.268.85s2.935-.284 4.268-.85a10.934 10.934 0 0 0 3.488-2.34 10.934 10.934 0 0 0 2.34-3.488c.566-1.333.85-2.756.85-4.268 0-1.531-.284-2.959-.85-4.282a10.977 10.977 0 0 0-2.34-3.474 10.933 10.933 0 0 0-3.488-2.34 10.939 10.939 0 0 0-.926-.343v-.718h-2.3c-.095-.553-.33-1.008-.703-1.363A1.843 1.843 0 0 0 11.025 0ZM6.946 1.091v1.684H4.265a.848.848 0 0 1-.608-.232.803.803 0 0 1-.245-.61c0-.229.08-.426.24-.593a.806.806 0 0 1 .606-.249h2.688Zm0 4.056V6.83H4.265a.862.862 0 0 1-.608-.226.77.77 0 0 1-.245-.593c0-.23.08-.43.24-.604a.788.788 0 0 1 .606-.261h2.688Zm2.771 12.876c.227.128.459.121.695-.02l5.331-3.418a.592.592 0 0 0 .327-.546.623.623 0 0 0-.327-.56l-5.33-3.417c-.237-.142-.469-.149-.696-.021a.63.63 0 0 0-.34.588v6.806c0 .265.114.46.34.588Z",
      clipRule: "evenodd"
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};